import Api from "@/lib/axios";

const ActiveCountryService = {
  getList(params) {
    return Api.get("/api/autopricing/onload/active-countries", {
      data: params,
      tenant: true
    }).then(
      response =>
        response?.data || {
          destCountries: [],
          sourceCountries: []
        }
    );
  }
};

export default ActiveCountryService;
